import { Observable } from './druid/./druid/Observable';
import { from as staticFrom } from './druid/./druid/observable/from';

Observable.from = staticFrom;

declare module './druid/./druid/Observable' {
  namespace Observable {
    export let from: typeof staticFrom;
  }
}